import React from 'react'

import { TabWrapper } from './styles'

const getSelectedTabStyles = (selected: boolean) =>
  selected
    ? {
        color: 'white',
        backgroundColor: '#247cdb',
      }
    : {}

interface TabsProps {
  tabs: { id: number; label: string }[]
  className?: string
  handleClick: (id: number) => void
}

const Tabs = ({ tabs, className, handleClick }: TabsProps) => {
  const [selectTab, setSelectTab] = React.useState(tabs[0].id)
  return (
    <TabWrapper className={className}>
      {tabs.map((item) => (
        <button
          key={item.id}
          className="border"
          onClick={() => {
            setSelectTab(item.id)
            handleClick(item.id)
          }}
          style={{
            ...getSelectedTabStyles(selectTab === item.id),
          }}
        >
          {item.label}
        </button>
      ))}
    </TabWrapper>
  )
}

export default Tabs
